import { render, staticRenderFns } from "./DealerForm.vue?vue&type=template&id=27adf338&scoped=true"
import script from "./DealerForm.vue?vue&type=script&lang=js"
export * from "./DealerForm.vue?vue&type=script&lang=js"
import style0 from "./DealerForm.vue?vue&type=style&index=0&id=27adf338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27adf338",
  null
  
)

export default component.exports